// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2yz38","vLegacy":"SelectSecondary_vLegacy__16a2K","error":"SelectSecondary_error__3-CN5","disabled":"SelectSecondary_disabled__Kmdtq"};